module.exports = __webpack_public_path__ + "img/hts2_2.22f437be.png";